import AsyncStorage from '@react-native-async-storage/async-storage'
import getEnvironment from 'app/environment'

export function buildStorageKey(key: string, userId?: string) {
  const baseKey = `${getEnvironment().name}-${key}`
  return userId ? `${userId}-${baseKey}` : baseKey
}

export async function clearStorage() {
  const keys = await AsyncStorage.getAllKeys()

  await Promise.all(
    keys.map(async key => {
      if (key.startsWith(getEnvironment().name)) {
        return AsyncStorage.removeItem(key)
      }
    })
  )
}
